const featureFlags = {
  FF_NEW_PERSISTENCE: false,
  FF_NEW_CHAT_LIST: true,
  FF_NEW_AUTH: true,
  FF_WEB_NEW_CHAT: true,
  FF_WEB_WS: true,
  /** Second WS to ephemeral-service (`/v1/ephemeral`) for typing/presence/read. */
  FF_EPHEMERAL_WS: true,
  /** Multi-person group create UI (`NewGroupModal`). */
  FF_GROUP_CREATE: true,
  // Off until backend + iOS-AUTH/AND-AUTH ship the password-reset
  // states. Screens exist and are reachable via standalone routing
  // only when this is on. The Wave-3 AuthFlow state machine is not
  // extended yet — these screens use their own local state.
  FF_AUTH_PASSWORD_RESET: false,
} as const;

export function isFeatureEnabled(flag: keyof typeof featureFlags): boolean {
  return featureFlags[flag];
}

export { featureFlags };
